<p>redirect-old-routes works!</p>
